export default __webpack_public_path__ + "static/media/marblebefore.a4f443b4.jpg";